import React, { PureComponent } from 'react';
import { withRouter } from '../../common/utils/NavigationWrapper';
import { connect } from 'react-redux';
import ReportRendererContainer from '../../common/components/ReportRenderer/ReportRendererContainer';
import InstrumentTelemetryContainer from './components/InstrumentTelemetry/InstrumentTelemetryContainer';
import FileTransferContainer from './components/FileTransfer/FileTransferContainer';
import ConfigurationContainer from './components/Configuration/ConfigurationContainer';
import LogBook from './components/LogBook/LogBook';
import PageContainer from '../../common/components/Page/PageContainer';
import Utils from '../../common/utils/Utils';
import InstrumentSummaryContainer from './components/InstrumentSummary/InstrumentSummaryContainer';
import './InstrumentDetails.css';
import NotFound from '../../pages/NotFound/NotFound';
import EventStatisticsContainer from './components/EventStatistics/EventStatisticsContainer';
import DesktopSharingContainer from './components/DesktopSharing/DesktopSharingContainer';
import Loading from '../../common/components/Loading/Loading';

const determineComponent = (pathname, instrument, sectionConfig) => {
  var crtPath = Utils.determineCurrentPath(pathname);

  if (crtPath && crtPath.startsWith('/report-')) {
    var query = {
      SelectedInstrument: instrument.SerialNumber,
      ReportName: crtPath.replace('/report-', ''),
    };
    return <ReportRendererContainer query={query} />;
  }

  switch (crtPath) {
    case '/event-statistics':
      return (
        <EventStatisticsContainer
          instrument={instrument}
          selectedViewMode={{ name: 'by day' }}
          reportSection="eventStatisticsReports"
          reports={
            sectionConfig['eventStatisticsSection']
              ? sectionConfig['eventStatisticsSection'].reports
              : []
          }
          selectedEventCategory={
            sectionConfig['eventStatisticsSection']
              ? sectionConfig['eventStatisticsSection'].reports.find(
                  (report) => report.defaultSelection
                )
              : {}
          }
        />
      );
    case '/instrument-telemetry':
      return (
        <InstrumentTelemetryContainer
          instrument={instrument}
          reportSection="telemetryReports"
          reports={
            sectionConfig['telemetrySection']
              ? sectionConfig['telemetrySection'].reports.sort((a, b) =>
                  a.displayName === b.displayName ? 0 : a.displayName > b.displayName ? 1 : -1
                )
              : []
          }
          selectedTable={
            sectionConfig['telemetrySection']
              ? sectionConfig['telemetrySection'].reports.find((report) => report.defaultSelection)
              : {}
          }
        />
      );
    case '/file-transfer':
      return <FileTransferContainer instrument={instrument} />;
    case '/desktop-sharing':
      return <DesktopSharingContainer instrument={instrument} />;
    case '/configuration':
      return <ConfigurationContainer instrument={instrument} />;
    case '/logBook':
      return <LogBook instrument={instrument} />;
    default:
      return <NotFound />;
  }
};

class InstrumentDetails extends PureComponent {
  render() {
    const { location, instrument, sectionConfig, selectorLinks, loading } = this.props;

    return (
      <PageContainer pageName="instrument-details">
        {loading === true ? (
          <Loading condition={true} />
        ) : (
          <div>
            <div className="instrument-details__left">
              <InstrumentSummaryContainer links={selectorLinks} instrument={instrument} />
            </div>
            <div className="instrument-details__right">
              {determineComponent(location.pathname, instrument, sectionConfig)}
            </div>
          </div>
        )}
      </PageContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default withRouter(connect(mapStateToProps)(InstrumentDetails));
